export default {
	home: {
		name: "add goods"
	},
	page_out_trade_no: "Número de Pedido del Comerciante",
	submit_modeling_model_file_not_ready:
		"El archivo del modelo aún no está listo. Inténtalo de nuevo más tarde o contacta con atención al cliente."
};
